import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ClientUser, LicenseState } from '@pixacare/domain';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CacheBuster } from 'ts-cacheable';

export const refreshClientUserDepartments$ = new Subject<void>();

@Injectable({
  providedIn: 'root',
})
export class ClientUserHttpService {
  private readonly http = inject(HttpClient);

  @CacheBuster({
    cacheBusterNotifier: refreshClientUserDepartments$,
  })
  addClientUser(clientCode: string, mailAddresses: string[], departmentId: number): Observable<ClientUser[]> {
    return this.http.put<ClientUser[]>(`${environment.apiBaseUrl}/client/User?cc=${clientCode}`, {
      mailAddress: mailAddresses,
      departmentId,
    });
  }

  updateClientUserLicenseState(
    clientCode: string,
    userId: number,
    licenseState: LicenseState,
  ): Observable<LicenseState> {
    return this.http.patch<LicenseState>(`${environment.apiBaseUrl}/license/`, { clientCode, userId, licenseState });
  }

  resendInvitation(userId: number): Observable<unknown> {
    return this.http.post(`${environment.apiBaseUrl}/user/ResendInvitationLink/${userId}`, { observe: 'response' });
  }
}
